<template>
  <div class="container-fluid">
    <div v-if="ground._id" class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ ground.groundName }}</h3>
            <p class="text-center">{{ ground.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div v-if="ground.imageUrl" class="text-center mb-3">
              <img :src="ground.imageUrl" alt="" style="max-width: 100%; max-height: 160px; object-fit: contain;" />
            </div>
            <div class="form-group px-3">
              <label class="form-control-label">تصویر نمایشی (ادمین)</label>
              <input type="file" class="form-control" accept="image/*" @change="imageSelected" />
              <button
                v-if="imageFile"
                type="button"
                class="btn btn-gradient-01 btn-sm mt-2 w-100"
                @click="uploadImage"
              >
                آپلود تصویر
              </button>
            </div>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات زمین</h4>
          </div>
          <div class="widget-body">
            <form id="groundForm" class="form-horizontal">
              <!-- ball theme -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع توپ</label>
                <div class="col-lg-6">
                  <input type="number" name="ballTheme" class="form-control" :value="ground.ballTheme" min="0" />
                </div>
              </div>
              <!-- ground bet coin -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">سکه ورودی زمین</label>
                <div class="col-lg-6">
                  <input
                    type="number"
                    name="groundBetCoin"
                    class="form-control"
                    :value="ground.groundBetCoin"
                    min="10"
                  />
                </div>
              </div>

              <!-- ground bet coin -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">محدودیت سطح کاربر</label>
                <div class="col-lg-6">
                  <input type="number" name="minLevel" class="form-control" :value="ground.minLevel" min="10" />
                </div>
              </div>
              <!-- ground farsi name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام فارسی زمین</label>
                <div class="col-lg-6">
                  <input type="text" name="groundFName" class="form-control" :value="ground.groundFName" />
                </div>
              </div>
              <!-- ground english name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام انگلیسی زمین</label>
                <div class="col-lg-6">
                  <input type="text" name="groundName" class="form-control" :value="ground.groundName" />
                </div>
              </div>
              <!-- ground  advertisment text -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">پیام تبلیغاتی (۵ - ۸)</label>
                <div class="col-lg-6">
                  <input type="text" name="advText" class="form-control" :value="ground.advText" />
                </div>
              </div>

              <!-- ground  advertisment text -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >پیام تبلیغاتی انگلیسی (۵ - ۸)</label
                >
                <div class="col-lg-6">
                  <input type="text" name="advTextEn" class="form-control" :value="ground.advTextEn" />
                </div>
              </div>
              <!-- groundIndex -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >ایندکس زمین در اپلیکیشن (این مورد باید با اپلیکیشن سازگار باشد، تغیرش ندهید)</label
                >
                <div class="col-lg-6">
                  <input type="number" name="groundIndex" class="form-control" :value="ground.groundIndex" />
                </div>
              </div>
              <!-- ground type -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع زمین</label>
                <div class="col-lg-6">
                  <input type="text" name="groundType" class="form-control" :value="ground.groundType" />
                </div>
              </div>
              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت زمین</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id>
                    <option value="true" :selected="ground.isAvailable">فعال</option>
                    <option value="false" :selected="!ground.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
              <!-- looser share -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">xp بازنده</label>
                <div class="col-lg-6">
                  <input type="number" name="loserShare" min="0" class="form-control" :value="ground.loserShare" />
                </div>
              </div>
              <!-- winner share -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">xp برنده</label>
                <div class="col-lg-6">
                  <input type="number" name="winnerShare" min="0" class="form-control" :value="ground.winnerShare" />
                </div>
              </div>
              <!-- friction -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">مقاومت زمین</label>
                <div class="col-lg-6">
                  <input type="number" name="friction" class="form-control" :value="ground.friction" />
                </div>
              </div>
              <!-- wallForce -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >قدرت بازگشت توپ از دیوار</label
                >
                <div class="col-lg-6">
                  <input type="number" name="wallForce" class="form-control" :value="ground.wallForce" />
                </div>
              </div>
              <!-- winRoles -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع بردن بازی</label>
                <div class="col-lg-6">
                  <select name="winRoles" class="form-control" id>
                    <option value="true" :selected="ground.winRoles.goal.isActive">گل</option>
                    <option value="false" :selected="ground.winRoles.time.isActive">زمان</option>
                  </select>
                </div>
              </div>
              <!-- max goals -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">تعداد گل</label>
                <div class="col-lg-6">
                  <input type="number" name="maxGoal" class="form-control" :value="ground.winRoles.goal.maxGoal" />
                </div>
              </div>
              <!-- max time -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">زمان بازی به ثانیه</label>
                <div class="col-lg-6">
                  <input type="number" name="maxTime" class="form-control" :value="ground.winRoles.time.maxTime" />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/grounds">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import groundService from '../../../../services/ground';
export default {
  name: 'grounddetail',
  data() {
    return {
      ground: {},
      imageFile: null,
    };
  },
  created() {
    this.getGround();
  },
  methods: {
    async getGround() {
      try {
        const ground = await groundService.getGround(this.$route.query.id);
        console.log(ground);
        this.ground = ground;
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('groundForm');
      const body = {
        _id: this.ground._id,
        ballTheme: form.ballTheme.value,
        groundBetCoin: form.groundBetCoin.value,
        groundFNameL: form.groundFName.value,
        groundName: form.groundName.value,
        groundIndex: form.groundIndex.value,
        groundType: form.groundType.value,
        isAvailable: form.isAvailable.value == 'true',
        loserShare: form.loserShare.value,
        winnerShare: form.winnerShare.value,
        friction: form.friction.value,
        wallForce: form.wallForce.value,
        advText: form.advText.value,
        advTextEn: form.advTextEn.value,
        minLevel: form.minLevel.value,
        winRoles: {
          goal: {
            isActive: form.winRoles.value == 'true',
            maxGoal: form.maxGoal.value,
          },
          time: {
            isActive: form.winRoles.value == 'false',
            maxTime: form.maxTime.value,
          },
        },
      };
      try {
        await groundService.updateGround(body);
        window.notif({ isError: false, mssg: 'بروز رسانی انجام شد' });

        this.getGround();
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });

        console.log(err);
      }

      console.log(body);
    },

    imageSelected(e) {
      this.imageFile = e.target.files[0] || null;
    },

    async uploadImage() {
      if (!this.imageFile) {
        return window.notif({ isError: true, mssg: 'تصویری انتخاب نشده است' });
      }
      const fileSizeMb = this.imageFile.size / 1024 / 1024;
      if (fileSizeMb > 2) {
        return window.notif({ isError: true, mssg: 'حجم فایل زیاد است (حداکثر ۲ مگابایت)' });
      }
      try {
        await groundService.uploadGroundImage(this.ground._id, this.imageFile);
        this.imageFile = null;
        await this.getGround();
        window.notif({ isError: false, mssg: 'تصویر آپلود شد' });
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی در آپلود تصویر پیش آمده' });
      }
    },
  },
};
</script>
